import { css } from "styled-components";

export const reset = css`
    ul,
    ol,
    dl {
        padding: 0;
        margin: 0;
    }

    li {
        list-style: none;
    }

    dt {
        font-weight: normal;
    }

    dd {
        margin-bottom: 0;
        margin-left: 0;
    }

    label {
        margin-bottom: unset;
    }

    a:not(.dit-components-link) {
        &:focus-visible {
            outline: none;
            box-shadow: var(--dit-layout-shadow-link-focus--map);
            border-radius: 0.25rem;
        }
    }
`;
